import { useForm } from "@iyk/vf-forms"
import { useAnalytics } from "@iyk/vf-observability/react"
import { Playlist } from "@iyk/vf-ui"
import { Routes } from "../check-in/ui/link.tsx"

export type LogoutButtonProps = {
  formClassName?: string
  buttonClassName?: string
}

export const LogoutButton = ({ formClassName, buttonClassName }: LogoutButtonProps) => {
  const { Form } = useForm()
  const analytics = useAnalytics()
  const playlist = Playlist.useAudioPlayer()

  const handleSubmit = () => {
    analytics.reset()
    playlist.reset()
  }

  return (
    <Form method="post" action={Routes.logout} className={formClassName} onSubmit={handleSubmit}>
      <button type="submit" className={buttonClassName}>
        Logout
      </button>
    </Form>
  )
}
